export function useGetProductPath(product: {
  id: string
  extensions?: { novuSeoUrls?: { [key: string]: string } }
} | null) {
  if (!product || !product.extensions?.novuSeoUrls) {
    return []
  }

  const { localeProperties } = useI18n()
  const { shopwareLangId } = localeProperties.value || {} // Fallback if localeProperties is undefined

  const seoUrls = product.extensions.novuSeoUrls || {}
  const path = seoUrls[shopwareLangId] || `/products/${product.id}` // Fallback to ID-based path

  return path
}
